import PageHeader from '../components/PageHeader.jsx';
import Positioning from '../components/Positioning.jsx';
import QuoteBand from '../components/QuoteBand.jsx';
import SnapPage from '../components/SnapPage.jsx';
import T from '../i18n/content.js';
import { useT } from '../i18n/LangContext.jsx';

export default function FirmPage() {
  const t = useT();
  const F = T.firm;
  return (
    <SnapPage>
      <PageHeader title={t(F.pageTitle)} lede={t(F.pageLede)} motif="motif-firm.png" motifSize="lg" lower />
      <Positioning asPage />
      <QuoteBand />
    </SnapPage>
  );
}
